import { Component, input, output } from '@angular/core';

/**
 * A plain dialog for the admin forms. The theme has no modal of its own and the storefront does
 * not load Bootstrap's JS, so this is a small backdrop plus a panel rather than a framework.
 */
@Component({
  selector: 'admin-modal',
  host: {
    style: 'display: contents'
  },
  styles: `
    .admin-backdrop {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, .5);
      z-index: 1100;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      overflow-y: auto;
      padding: 40px 15px;
    }

    .admin-panel {
      background: #fff;
      border-radius: 4px;
      width: 100%;
      max-width: 640px;
      padding: 25px 30px;
    }

    .admin-panel h4 {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    `,
  template: `
    <div class="admin-backdrop" (click)="closed.emit()">
      <div class="admin-panel" (click)="$event.stopPropagation()">
        <h4 class="m-text20 p-b-24">
          {{title()}}
          <button type="button" class="s-text8" aria-label="Закрити" (click)="closed.emit()">
            <span class="fa fa-times"></span>
          </button>
        </h4>
        <ng-content />
      </div>
    </div>
    `
})
export class AdminModalComponent {

  readonly title = input.required<string>();
  readonly closed = output<void>();

}
